<form class="m-1" novalidate [formGroup]="form" (ngSubmit)="submit(form.value)">
  <div class="mb-3"><p>Wir haben nicht mit so einem Ansturm gerechnet! Wir benachrichtigen dich, sobald das Produkt wieder bei uns auf Lager ist.</p></div>
  <div class="mb-3">
    <input placeholder="E-Mail-Adresse" type="email" class="form-control" formControlName="email">
  </div>
  <button type="submit" class="btn btn-primary" [disabled]="! form.valid">Gib mir Bescheid!</button>
</form>
